import { Link as MuiLink, type LinkProps as MuiLinkProps } from '@mui/material';

interface ArrowLinkProps extends Omit<MuiLinkProps, 'children'> {
  children: React.ReactNode;
}

const ArrowLink: React.FC<ArrowLinkProps> = ({
  children,
  target = '_blank',
  rel = 'noopener noreferrer',
  underline = 'hover',
  sx,
  ...rest
}: ArrowLinkProps) => (
  <MuiLink target={target} rel={rel} underline={underline} sx={{ typography: 'p3b', whiteSpace: 'nowrap', ...sx }} {...rest}>
    {children} →
  </MuiLink>
);

export default ArrowLink;
